import styled from 'styled-components/macro';

export const BaseList = styled.ul`
  margin: 0;
  display: flex;
  flex-direction: column;
`;
